import { Injectable } from '@angular/core';
import { AppConfig } from './app.config.services';
import { Router } from '@angular/router';
import { TrsEventsService } from './trsevents.service';
import { log } from '../utils/logging';
import { LogUpload } from '../utils/log-upload';
import { IRegisterRequestPayload, ISWFHMessagePayload } from '../interfaces/messages';
import { generateMessage } from '../utils/messages';

@Injectable()
export class wsService {
  hb_interval: number = 15 * 1000; //in milliseconds
  hb_sent: number = 0;
  hb_on: boolean = true;
  was_close_requested: boolean = false;
  handle_login_requested: boolean = false;
  private socket$: WebSocket;

  registerCompleteTimeout: NodeJS.Timeout;
  traceId: string;

  logUploader: LogUpload = new LogUpload("wsService");

  constructor(private router: Router, private trsService: TrsEventsService) { }

  public connect(): void {
    log.info(`Connecting to SWFH Server WS`);
    this.logUploader.info("connect", "WS Connected");
    if (!this.socket$ || this.socket$.readyState === WebSocket.CLOSED) {
      this.socket$ = new WebSocket(AppConfig.settings.defaults.TRSServerURL);
      this.subscribeToSocketEvents();
      this.hb_sent = 0;
      this.hb_on = true;
    }
  }

  getSupervisorId() {
    if (window.name) {
      const params = JSON.parse(window.name);
      const supervisorId: string = params.supervisorId;
      return supervisorId;
    }
    else {
      return '';
    }
  }

  getTraceId() {
    if (window.name) {
      const params = JSON.parse(window.name);
      const traceId: string | null = params.traceId;
      return traceId;
    }
    else {
      return '';
    }
  }

  sendMessage(msg: any): void {
    this.socket$.send(msg);
  }

  private subscribeToSocketEvents = (): void => {
    this.socket$.onopen = (event: Event): void => {
      log.info(`SWFH Server WS Connected`);
      this.logUploader.info("connect", "WS Connected");

      if (this.trsService.supervisorId != null && this.trsService.supervisorId !== "") {
        log.info(`Sending Login Request`);
        this.handleLoginRequest(this.trsService.supervisorId);
      }
      else {
        log.info(`Routing`);
        this.router.navigate([""]);
      }

      this.trsService.evtdata.next({
        eventName: "WEBSOCKET_OPENED",
        data: {},
      });

      this.supervisorHeartbeat();
    }

    this.socket$.onmessage = (event: MessageEvent): void => {
      if (event.data != null) {
        this.trsService.evtdata.next({
          eventName: "REDIRECT_RESPONSE",
          data: event.data,
        });
      }
    }

    this.socket$.onclose = (event: CloseEvent): void => {
      log.info(`OnClose Event received from server`, event);

      if (this.was_close_requested === false) {
        log.info(`Reconnecting to SWFH Server WS`)
        this.logUploader.info("connecting", "WS Reconnecting");
        this.hb_sent = 0;
        this.hb_on = true;
        this.connect();
      }
      else {
        this.hb_on = false;
      }

      this.trsService.evtdata.next({
        eventName: "WEBSOCKET_CLOSED",
        data: 'success'
      });
    }

    this.socket$.onerror = (event: Event): void => {
      log.info(`OnError Event received from server`, event);

      if (this.was_close_requested === false) {
        log.info(`Reconnecting to SWFH Server WS`)
        this.logUploader.info("connecting", "WS Reconnecting");
        this.hb_sent = 0;
        this.hb_on = true;
        this.connect();
      }
      else {
        this.hb_on = false;
      }
    }
  }

  closeWebSocket() {
    this.was_close_requested = true;

    if (this.socket$.readyState !== WebSocket.CLOSING && this.socket$.readyState !== WebSocket.CLOSED) {
      this.socket$.close();

      log.info(`SWFH Server WS Connection Closed`);
    }
  }

  supervisorHeartbeat() {
    if (this.hb_on === true) {
      this.hb_sent++;
      log.debug(`Heartbeat request sent (${this.hb_sent})`);

      this.sendMessage(this.trsService.isLoggedIn === true ? 'PING': 'HEARTBEAT');

      setTimeout(() => {
        this.supervisorHeartbeat();
      }, this.hb_interval);
    }
  }

  handleLoginRequest = (agentLanId: string | null): void => {
    log.debug(`handleLoginRequest`, agentLanId);
    if (agentLanId == null || agentLanId === "") {
      this.router.navigate([""]);
      return;
    }
    this.trsService.supervisorId = agentLanId.toUpperCase();

    const payload: IRegisterRequestPayload = {
      Id: `SUPERVISOR_${agentLanId.toUpperCase()}`, // The LanID of the supervisor. SUPERVISOR_ prfix is required for TRS Server to undersand that its Supervisor login
      time: new Date(),
      Allowed: AppConfig.settings.Allowed
    };
    const message: ISWFHMessagePayload = generateMessage("REGISTER", "", payload, this.trsService);

    log.info(`REQUEST REGISTER`, message);
    this.sendMessage(JSON.stringify(message));
    this.registerCompleteTimeout = setTimeout(() => {
      this.registerTimedOut();
    }, 10000);
  }

  onRegisterResponse = (): void => {
    clearTimeout(this.registerCompleteTimeout);
  }

  registerTimedOut = (): void => {
    this.logUploader.warn("registerTimedOut", "Login timed out");
    window.errorObj = 'Unable to Login (REGISTER failed)';
    this.router.navigate(["error"]);
  }

  handleHeartbeatResponse = (): void => {
    log.debug(`Heartbeat response received`);
    this.hb_sent = 0;

    if (this.trsService.supervisorId != null && this.trsService.supervisorId !== "")
      window.localStorage.setItem("___lastHeartbeatAck", new Date().getTime().toString());
  }
}
